<template>
  <!--  移动到  -->
  <el-dialog :visible="show" title="移动到分类" width="250px" append-to-body @close="$emit('update:show', false)">
    <div class="select-category-list">
      <div class="item">
        <el-radio v-model="media_category_id" :label="0">未分组</el-radio>
      </div>
      <div class="item" v-for="item in category" :key="item.id">
        <el-radio v-model="media_category_id" :label="item.id">{{ item.name }}</el-radio>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:show', false)" size="small">关闭</el-button>
      <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading" size="small" :disabled="media_category_id === ''">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['show', 'category', 'rows'],

  data() {
    return {
      media_category_id: '',
      doSubmitLoading: false,
    };
  },

  methods: {
    async doSubmit() {
      this.doSubmitLoading = true;
      try {
        await this.api.media.updateMedia({
          ids: this.rows.map((item) => item.id),
          field_data: { media_category_id: this.media_category_id },
        });
        this.$message.success('移动成功');
        this.$emit('success');
        this.$emit('update:show', false);
      } catch (e) {
        console.error(e);
      }
      this.doSubmitLoading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.select-category-list {
  padding-left: 50px;

  .item {
    margin-bottom: 5px;
  }
}
</style>
